module.exports = __webpack_public_path__ + "static/the-resilience-fund-d9a0116ffb15df88000c3f8dcbfd8448.svg";